import React from 'react';
import { NavigationDots, SocialMedia } from '../components';
import useSanity from '../customHooks/useSanity';
const AppWrap = (Component, idName, classNames) => function HOC() {
  const { profile}=useSanity()
  const name = profile.name;
  /* Get Current year */
  const date = new Date();
  const year = date.getFullYear();

  return (
    <div id={idName} className={`app__container ${classNames}`}>
      <SocialMedia />
      <div className="app__wrapper app__flex">
        <Component />

        <div className="copyright">
          <p className="p-text">&copy;{year} {name}</p>
          <p className="p-text">All rights reserved</p>
        </div>
      </div>
      <NavigationDots active={idName} />
    </div>
  );
};

export default AppWrap;
